/**
* @file 业务设置-排班管理-查看/编辑排班
* */
<template>
  <div id="operationData">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="order">
        <template slot="label"><i class="el-icon-document" style="margin-right:4px"></i>订单</template>
        <div class="condition">
          <div>
            <el-select v-if="mixinUserInfo.organizationType == 1" v-model="order.organizationId"
                       placeholder="请选择机构名称" @change="sortFn" filterable clearable>
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
              </el-option>
            </el-select>
            <el-radio-group v-model="order.timeType" size="mini">
              <el-radio-button border :label="1">昨日</el-radio-button>
              <el-radio-button :label="2">最近7天</el-radio-button>
              <el-radio-button :label="3">最近30天</el-radio-button>
              <el-radio-button :label="4">最近半年</el-radio-button>
              <el-radio-button :label="5">最近一年</el-radio-button>
              <el-radio-button :label="6">从始至终</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="order.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" size="mini">
            </el-date-picker>
            <span style="line-height: 28px; margin-right: 0">数据排序：</span>
            <el-select v-model="order.orderSort" size="mini" clearable>
              <el-option label="创建订单-从高到低" :value="1"></el-option>
              <el-option label="取消订单-从高到低" :value="2"></el-option>
              <el-option label="支付订单-从高到低" :value="3"></el-option>
              <el-option label="退票订单-从高到低" :value="4"></el-option>
              <el-option label="完成订单-从高到低" :value="5"></el-option>
            </el-select>
          </div>
          <el-button size="mini" @click="exportFn('OperationDataOrder')">导出</el-button>
        </div>
        <div class="blueInfo">
          <p>* 取消订单：下单待支付时，被取消或支付时效过期的订单</p>
          <p>* 退票订单：下单支付后，被退票的订单</p>
        </div>
        <el-table show-summary :summary-method="summariesOrder" border stripe  size="mini"
                  class="zoeTable" style="margin-bottom: 12px" empty-text="暂无数据" v-loading="order.loading"
                  :data="order.table">
          <el-table-column v-for="(item, index) in order.columns" :key="index" :show-overflow-tooltip="true"
                           :prop="item.prop" :label="item.label">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="pay">
        <template slot="label"><i class="el-icon-money" style="margin-right:4px"></i>交易</template>
        <div class="condition">
          <div>
            <el-select v-if="mixinUserInfo.organizationType == 1" v-model="pay.organizationId"
                       placeholder="请选择机构名称" @change="sortFn" filterable clearable>
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
              </el-option>
            </el-select>
            <el-radio-group v-model="pay.timeType" size="mini">
              <el-radio-button :label="1">昨日</el-radio-button>
              <el-radio-button :label="2">最近7天</el-radio-button>
              <el-radio-button :label="3">最近30天</el-radio-button>
              <el-radio-button :label="4">最近半年</el-radio-button>
              <el-radio-button :label="5">最近一年</el-radio-button>
              <el-radio-button :label="6">从始至终</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="pay.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" size="mini">
            </el-date-picker>
            <span style="line-height: 28px; margin-right: 0">数据排序：</span>
            <el-select v-model="pay.paySort" size="mini" clearable>
              <el-option label="支付金额-从高到低" :value="1"></el-option>
              <el-option label="退票金额-从高到低" :value="2"></el-option>
              <el-option label="成交金额-从高到低" :value="3"></el-option>
              <el-option label="平台收入-从高到低" :value="4"></el-option>
            </el-select>
          </div>
          <el-button size="mini" @click="exportFn('OperationDataPay')">导出</el-button>
        </div>
        <div class="blueInfo">
          <p>* 成交金额：完成订单的支付金额</p>
          <p>* 平台收入：扣除司机提成后，平台的订单收入</p>
        </div>
        <el-table show-summary :summary-method="summariesPay" border stripe max-height="680" size="mini"
                  class="zoeTable" style="margin-bottom: 12px" empty-text="暂无数据" v-loading="pay.loading"
                  :data="pay.table">
          <el-table-column v-for="(item, index) in pay.columns" :key="index" :show-overflow-tooltip="true"
                           :prop="item.prop" :label="item.label">
            <template slot-scope="{ row }">
              <template v-if="
                  item.prop === 'payCount' ||
                  item.prop === 'refundCount' ||
                  item.prop === 'realFeeCount' ||
                  item.prop === 'companyIncome'
                ">
                <span> ￥{{ row[item.prop] ? row[item.prop] : "0" }} </span>
              </template>
              <template v-else>{{
                  row[item.prop] ? row[item.prop] : "-"
                }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="resource">
        <template slot="label"><i class="el-icon-s-grid" style="margin-right:4px"></i>资源</template>
        <div class="condition">
          <div>
            <el-select v-if="mixinUserInfo.organizationType == 1" v-model="resource.organizationId"
                       placeholder="请选择机构名称" @change="sortFn" filterable clearable>
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
              </el-option>
            </el-select>
            <el-radio-group v-model="resource.timeType" size="mini">
              <el-radio-button :label="1">昨日</el-radio-button>
              <el-radio-button :label="2">最近7天</el-radio-button>
              <el-radio-button :label="3">最近30天</el-radio-button>
              <el-radio-button :label="4">最近半年</el-radio-button>
              <el-radio-button :label="5">最近一年</el-radio-button>
              <el-radio-button :label="6">从始至终</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="resource.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" size="mini">
            </el-date-picker>
            <span style="line-height: 28px; margin-right: 0">数据排序：</span>
            <el-select v-model="resource.resourcesSort" size="mini" clearable>
              <el-option label="司机总数-从高到低" :value="1"></el-option>
              <el-option label="车辆总数-从高到低" :value="2"></el-option>
              <el-option label="运营车辆-从高到低" :value="3"></el-option>
              <el-option label="线路总数-从高到低" :value="4"></el-option>
              <el-option label="运营线路-从高到低" :value="5"></el-option>
            </el-select>
          </div>
          <el-button size="mini" @click="exportFn('OperationDataResource')">导出</el-button>
        </div>
        <div class="blueInfo">
          <p>* 运营车辆：产生了工单的车辆</p>
          <p>* 运营线路：产生了订单的线路</p>
        </div>
        <el-table show-summary :summary-method="summariesResource" border stripe max-height="680" size="mini"
                  class="zoeTable" style="margin-bottom: 12px" empty-text="暂无数据" v-loading="resource.loading"
                  :data="resource.table">
          <el-table-column v-for="(item, index) in resource.columns" :key="index" :show-overflow-tooltip="true"
                           :prop="item.prop" :label="item.label">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane name="line">
        <template slot="label"><i class="el-icon-map-location" style="margin-right:4px"></i>线路</template>
        <div class="condition">
          <div>
            <el-select v-if="mixinUserInfo.organizationType == 1" v-model="line.organizationId"
                       placeholder="请选择机构名称" @change="sortFn" filterable clearable>
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
              </el-option>
            </el-select>
            <el-radio-group v-model="line.timeType" size="mini">
              <el-radio-button :label="1">昨日</el-radio-button>
              <el-radio-button :label="2">最近7天</el-radio-button>
              <el-radio-button :label="3">最近30天</el-radio-button>
              <el-radio-button :label="4">最近半年</el-radio-button>
              <el-radio-button :label="5">最近一年</el-radio-button>
              <el-radio-button :label="6">从始至终</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="line.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" size="mini">
            </el-date-picker>
            <span style="line-height: 28px; margin-right: 0">数据排序：</span>
            <el-select v-model="line.lineSort" size="mini" clearable>
              <el-option label="创建订单-从高到低" :value="1"></el-option>
              <el-option label="支付订单-从高到低" :value="2"></el-option>
              <el-option label="退票/取消订单-从高到低" :value="3"></el-option>
              <el-option label="完成订单-从高到低" :value="4"></el-option>
              <el-option label="支付金额-从高到低" :value="5"></el-option>
              <el-option label="退票金额-从高到低" :value="6"></el-option>
              <el-option label="成交金额-从高到低" :value="7"></el-option>
            </el-select>
          </div>
          <el-button size="mini" @click="exportFn('OperationDataLine')">导出</el-button>
        </div>
        <div class="blueInfo" style="padding: none; background: none"></div>
        <el-table show-summary :summary-method="summariesLine" border stripe max-height="680" size="mini"
                  class="zoeTable" style="margin-bottom: 12px" empty-text="暂无数据" v-loading="line.loading"
                  :data="line.table">
          <el-table-column v-for="(item, index) in line.columns" :key="index" :show-overflow-tooltip="true"
                           :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="{ row }">
              <template v-if="
                  item.prop === 'payCount' ||
                  item.prop === 'refundCount' ||
                  item.prop === 'realFeeCount'
                ">
                <span> ￥{{ row[item.prop] ? row[item.prop] : "0" }} </span>
              </template>
              <template v-else>{{
                  row[item.prop] ? row[item.prop] : "-"
                }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog class="dialog-export-modal" :visible.sync="exportShow" title="导出数据" width="600px"
               :close-on-click-modal="false">
      <el-checkbox v-for="(item, index) in exportHeaders" v-model="item.isChecked" :key="index">
        {{ item.title }}
      </el-checkbox>
      <template slot="footer">
        <el-button :loading="exportLoading" type="primary" @click="exportConfirmFn">确定</el-button>
        <el-button @click="exportShow = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "operationData",
  data() {
    return {
      tabAction: null,
      // 切页面初次加载触发
      orderFirst: true,
      payFirst: true,
      resourceFirst: true,
      lineFirst: true,
      order: {
        searchType: 1,
        organizationId: '',
        timeType: 1,
        date: [],
        orderSort: 1,
        loading: false,
        table: null,
        columns: [
          {prop: "organizationName", label: "机构名称"},
          {prop: "orderCreateNum", label: "创建订单"},
          {prop: "orderCancelNum", label: "取消订单"},
          {prop: "orderCancelRatio", label: "订单取消率"},
          {prop: "orderPayNum", label: "支付订单"},
          {prop: "orderRefundNum", label: "退票订单"},
          {prop: "orderRefundRatio", label: "订单退票率"},
          {prop: "orderFinishNum", label: "完成订单"},
          {prop: "orderFinishRatio", label: "订单完成率"},
        ],
      },
      pay: {
        searchType: 1,
        timeType: 1,
        organizationId: '',
        date: [],
        paySort: 1,
        loading: false,
        table: null,
        columns: [
          {prop: "organizationName", label: "机构名称"},
          {prop: "payCount", label: "支付金额"},
          {prop: "refundCount", label: "退票金额"},
          {prop: "realFeeCount", label: "成交金额"},
          {prop: "companyIncome", label: "平台收入"},
        ],
      },
      resource: {
        searchType: 1,
        organizationId: '',
        timeType: 1,
        date: [],
        resourcesSort: 1,
        loading: false,
        table: null,
        columns: [
          {prop: "organizationName", label: "机构名称"},
          {prop: "driverCreateNum", label: "新增司机"},
          {prop: "driverTotalNum", label: "司机总数"},
          {prop: "vehicleCreateNum", label: "新增车辆"},
          {prop: "vehicleTotalNum", label: "车辆总数"},
          {prop: "vehicleServiceNum", label: "运营车辆"},
          {prop: "vehicleServiceRatio", label: "车辆运营率"},
          {prop: "lineCreateNum", label: "新增线路"},
          {prop: "lineTotalNum", label: "线路总数"},
          {prop: "lineServiceNum", label: "运营线路"},
          {prop: "lineServiceRatio", label: "线路运营率"},
        ],
      },
      line: {
        searchType: 1,
        organizationId: '',
        timeType: 1,
        date: [],
        lineSort: 1,
        loading: false,
        table: null,
        columns: [
          {prop: "organizationName", label: "机构名称"},
          {prop: "stationName", label: "线路名称", width: 400},
          {prop: "orderCreateNum", label: "创建订单"},
          {prop: "orderPayNum", label: "支付订单"},
          {prop: "orderRefundAndCancelNum", label: "退票/取消订单"},
          {prop: "orderFinishNum", label: "完成订单"},
          {prop: "payCount", label: "支付金额"},
          {prop: "refundCount", label: "退票金额"},
          {prop: "realFeeCount", label: "成交金额"},
          {prop: "orderPassengerNum", label: "载客人数"},
        ],
      },
      exportShow: false, //显示
      excelType: null, //表名
      exportHeaders: [], //表头
      exportLoading: false,
    };
  },
  watch: {
    "order.timeType"(val) {
      if (val) {
        this.order.searchType = 1;
        this.order.date = null;
        this.getOrder();
      }
    },
    "order.date"(val) {
      if (val) {
        this.order.searchType = 2;
        this.order.timeType = null;
        this.getOrder();
      } else {
        if (!this.order.timeType) {
          this.order.timeType = 1;
        }
      }
    },
    "pay.timeType"(val) {
      if (val) {
        this.pay.searchType = 1;
        this.pay.date = null;
        this.getPay();
      }
    },
    "pay.date"(val) {
      if (val) {
        this.pay.searchType = 2;
        this.pay.timeType = null;
        this.getPay();
      } else {
        if (!this.pay.timeType) {
          this.pay.timeType = 1;
        }
      }
    },
    "resource.timeType"(val) {
      if (val) {
        this.resource.searchType = 1;
        this.resource.date = null;
        this.getResource();
      }
    },
    "resource.date"(val) {
      if (val) {
        this.resource.searchType = 2;
        this.resource.timeType = null;
        this.getResource();
      } else {
        if (!this.resource.timeType) {
          this.resource.timeType = 1;
        }
      }
    },
    "line.timeType"(val) {
      if (val) {
        this.line.searchType = 1;
        this.line.date = null;
        this.getLine();
      }
    },
    "line.date"(val) {
      if (val) {
        this.line.searchType = 2;
        this.line.timeType = null;
        this.getLine();
      } else {
        if (!this.line.timeType) {
          this.line.timeType = 1;
        }
      }
    },
    "order.orderSort"() {
      this.getOrder();
    },
    "pay.paySort"() {
      this.getPay();
    },
    "resource.resourcesSort"() {
      this.getResource();
    },
    "line.lineSort"() {
      this.getLine();
    },
    tabAction(val) {
      if (val == "order" && this.orderFirst) {
        this.getOrder();
        this.orderFirst = false;
      } else if (val == "pay" && this.payFirst) {
        this.getPay();
        this.payFirst = false;
      } else if (val == "resource" && this.resourceFirst) {
        this.getResource();
        this.resourceFirst = false;
      } else if (val == "line" && this.lineFirst) {
        this.getLine();
        this.lineFirst = false;
      }
    },
  },
  methods: {
    sortFn() {
      this.getOrder()
      this.getPay()
      this.getResource()
      this.getLine()
    },
    async getOrder() {
      this.order.loading = true;
      let url = "/api/v1/manage/operationData/order";
      let params = {
        orderSort: this.order.orderSort,
        timeType: this.order.timeType,
        organizationId: this.order.organizationId,
        startTime:
            this.order.searchType == 2
                ? this.order.date
                    ? this.order.date[0] / 1000
                    : null
                : null,
        endTime:
            this.order.searchType == 2
                ? this.order.date
                    ? this.order.date[1] / 1000 + 86399
                    : null
                : null,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.order.table = data.data;
      }
      this.order.loading = false;
    },
    async getPay() {
      this.pay.loading = true;
      let url = "/api/v1/manage/operationData/pay";
      let params = {
        paySort: this.pay.paySort,
        timeType: this.pay.timeType,
        organizationId: this.pay.organizationId,
        startTime:
            this.pay.searchType == 2
                ? this.pay.date
                    ? this.pay.date[0] / 1000
                    : null
                : null,
        endTime:
            this.pay.searchType == 2
                ? this.pay.date
                    ? this.pay.date[1] / 1000 + 86399
                    : null
                : null,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.pay.table = data.data;
      }
      this.pay.loading = false;
    },
    async getResource() {
      this.resource.loading = true;
      let url = "/api/v1/manage/operationData/resource";
      let params = {
        resourcesSort: this.resource.resourcesSort,
        timeType: this.resource.timeType,
        organizationId: this.resource.organizationId,
        startTime:
            this.resource.searchType == 2
                ? this.resource.date
                    ? this.resource.date[0] / 1000
                    : null
                : null,
        endTime:
            this.resource.searchType == 2
                ? this.resource.date
                    ? this.resource.date[1] / 1000 + 86399
                    : null
                : null,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.resource.table = data.data;
      }
      this.resource.loading = false;
    },
    async getLine() {
      this.line.loading = true;
      let url = "/api/v1/manage/operationData/line";
      let params = {
        lineSort: this.line.lineSort,
        timeType: this.line.timeType,
        organizationId: this.line.organizationId,
        startTime:
            this.line.searchType == 2
                ? this.line.date
                    ? this.line.date[0] / 1000
                    : null
                : null,
        endTime:
            this.line.searchType == 2
                ? this.line.date
                    ? this.line.date[1] / 1000 + 86399
                    : null
                : null,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.line.table = data.data;
      }
      this.line.loading = false;
    },
    summariesOrder(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        // 带%的字段
        const specialColumns = new Map([
          ["orderCancelRatio", "orderCancelNum"],
          ["orderRefundRatio", "orderRefundNum"],
          ["orderFinishRatio", "orderFinishNum"],
        ]);
        let special = specialColumns.get(column.property); //获取百分比列的总数数据
        let orderCreateNum = 0; //创建订单
        let calculation = 0; //计算列
        if (data) {
          const values = data.map((item) => {
            if (special) {
              orderCreateNum += item.orderCreateNum;
              calculation += item[special];
              return Number(item[column.property].slice(0, -1));
            } else {
              return Number(item[column.property]);
            }
          });

          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            if (special) {
              if (orderCreateNum) {
                sums[index] =
                    ((calculation / orderCreateNum) * 100).toFixed(2) + "%";
              } else {
                sums[index] = "0%";
              }
            }
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    summariesPay(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (data) {
          const values = data.map((item) => {
            return Number(item[column.property]);
          });

          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = "￥" + sums[index].toFixed(2);
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    summariesResource(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        // 带%的字段
        const specialColumns = new Map([
          ["vehicleServiceRatio", "vehicleServiceNum"],
          ["lineServiceRatio", "lineServiceNum"],
        ]);
        let special = specialColumns.get(column.property);
        let totalNum = 0; //总数
        let calculation = 0; //计算列
        if (data) {
          const values = data.map((item) => {
            if (special) {
              totalNum +=
                  item[
                      special == "vehicleServiceNum"
                          ? "vehicleTotalNum"
                          : "lineTotalNum"
                      ];
              calculation += item[special];
              return Number(item[column.property].slice(0, -1));
            } else {
              return Number(item[column.property]);
            }
          });

          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            if (special) {
              if (totalNum) {
                sums[index] = ((calculation / totalNum) * 100).toFixed(2) + "%";
              } else {
                sums[index] = "0%";
              }
            }
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    summariesLine(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        // 带￥的字段
        const specialColumns = new Map([
          ["payCount", true],
          ["refundCount", true],
          ["realFeeCount", true],
        ]);
        let special = specialColumns.get(column.property);
        if (data) {
          const values = data.map((item) => {
            return Number(item[column.property]);
          });

          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            if (special) {
              sums[index] = "￥" + sums[index].toFixed(2);
            }
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async exportFn(type) {
      this.exportShow = true;
      let exportHeaders = [];
      let url = "/api/v1/common/excel/header";
      let params = {
        excelType: type,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1 && data.data) {
        this.excelType = type;
        exportHeaders = data.data.split(",").map(item =>
            item = {
              isChecked: true,
              title: item,
            }
        );
      }
      this.exportHeaders = exportHeaders;
    },
    async exportConfirmFn() {
      const specialColumns = new Map([
        ["OperationDataOrder", "order"],
        ["OperationDataPay", "pay"],
        ["OperationDataResource", "resource"],
        ["OperationDataLine", "line"],
      ]);
      let tableName = specialColumns.get(this.excelType);
      if (this[tableName].table.length == 0) {
        this.$message.warning("导出数据不能为空");
        return;
      }
      let header = [];
      this.exportHeaders.forEach((item) => {
        if (item.isChecked) {
          header.push(item.title);
        }
      });
      if (header.length < 1) {
        this.$message.warning("请选择导出表头");
        return;
      }
      this.exportLoading = true;
      let params = {
        timeType: this[tableName].timeType,
        startTime: this[tableName].date[0],
        endTime: this[tableName].date[1],
        orderSort: this[tableName].orderSort,
        paySort: this[tableName].paySort,
        resourceSort: this[tableName].resourceSort,
        lineSort: this[tableName].lineSort,
      };
      params.excelType = this.excelType;
      params.header = header.join(",");
      let data = await this.$axios.get("/api/v1/common/excel", params);
      this.exportLoading = false;
      if (data && data.code === 1) {
        this.exportShow = false;
        this.$store.dispatch("acExcelForm", data.data);
        this.$mqtt.newTopic({
          tpc: data.data.topic,
          opt: {
            qos: 1,
          },
        });
      }
    },
  },
  async created() {
    this.tabAction = "order";
    if (this.mixinUserInfo.organizationType != 1) {
      this.order.organizationId = this.mixinUserInfo.organizationId
      this.pay.organizationId = this.mixinUserInfo.organizationId
      this.resource.organizationId = this.mixinUserInfo.organizationId
      this.line.organizationId = this.mixinUserInfo.organizationId
    }
    await this.mixinOrganizations();
  },
  mounted() {
  },
};
</script>

<style lang="less">
#operationData {
  .condition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    & > div > * {
      margin-right: 30px;
      vertical-align: middle;
    }
  }
}
</style>
